module.exports = __webpack_public_path__ + "static/008-84fb8d2ff6f392b1f553b83dcb150a2a.jpeg";